/*
 * @Descripttion:
 * @version:
 * @Author: wlk
 * @Date: 2023-12-19 20:08:23
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-12-25 10:51:28
 */
import request from '@/service/request'

export default class getPhoneService {
  /**
   * 获取明文手机号
   * @param data
   * @returns
   */
  static getPhone(data: any): Promise<any> {
    return request.post('/phoneManage/getPhone', data)
  }
}
